<div class="layout">
  <!-- LEFT: maroon brand panel -->
  <div class="brand-panel">
    <div class="anim d3">
      <h1 class="headline">A new model for<br/><em>creative execution.</em></h1>
      <p class="lede">Structured by AI, delivered with human expertise — built on a century of Mahatta's production legacy. We solve the beginning, where most projects fail before execution begins.</p>
    </div>

    <div style="height: 40px;"></div>

    <div class="anim d4">
      <p class="framework-label">THE FOUR-PART PLATFORM</p>
      <div class="stage-grid">
        <div class="stage-card">
          <div class="stage-num">01</div>
          <div class="stage-name">Scope</div>
          <div class="stage-desc">AI-assisted project planning</div>
        </div>
        <div class="stage-card">
          <div class="stage-num">02</div>
          <div class="stage-name">Source</div>
          <div class="stage-desc">AI-assisted partner matching</div>
        </div>
        <div class="stage-card">
          <div class="stage-num">03</div>
          <div class="stage-name">Bid</div>
          <div class="stage-desc">Structured bid comparison</div>
        </div>
        <div class="stage-card">
          <div class="stage-num">04</div>
          <div class="stage-name">Execute</div>
          <div class="stage-desc">End-to-end project delivery</div>
        </div>
      </div>
    </div>

    <div class="anim d5 footer-row">
      <div>
        <div class="stat-label" style="margin-top: 0;">BY MAHATTA</div>
        <div class="footer-line"><span class="footer-line-animated">Serving Creativity since 1915</span></div>
      </div>
    </div>
  </div>

  <!-- RIGHT: panel with logo + auth -->
  <div class="action-panel">
    <div class="panel-body">
      <div class="anim d2 center" style="margin-bottom: 36px; text-align: center;">
        <img src="../../../../assets/images/logos/studioip logo black.png" alt="StudioIP" style="height: 32px; width: auto; display: inline-block;" />
        <div style="font-size: 10px; letter-spacing: 0.4px; color: var(--text-tertiary); margin-top: 10px;">India's 1<sup>st</sup> AI-assisted creative execution platform</div>
      </div>

      <!-- INITIAL STATE -->
      <div *ngIf="uiState === 'initial'">
        <div class="anim d3 center" style="margin-bottom: 32px;">
          <p class="eyebrow">GET STARTED</p>
          <h2 class="panel-h2" style="margin-top: 6px;">Welcome</h2>
        </div>
        <button class="primary-btn anim d4" (click)="setUiState('signup')">
          Scope your next project
          <i class="ti ti-arrow-right" style="font-size: 15px;"></i>
        </button>
        <div class="anim d5 divider" style="margin: 28px 0 18px;"><hr/><span>EXISTING CLIENT?</span><hr/></div>
        <button class="secondary-btn anim d6" routerLink="/customers/login">
          <i class="ti ti-login-2" style="font-size: 15px;"></i>
          Log in to your account
        </button>
      </div>

      <!-- SIGNUP STATE (Unified Email/Phone OTP) -->
      <div *ngIf="uiState === 'signup'">
        <div class="back-link back-link-offset" (click)="setUiState('initial')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left"
            viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
          </svg> Back
        </div>
        <p class="eyebrow">SCOPE YOUR PROJECT</p>
        <h2 class="panel-h2">Create your <em>account</em></h2>
        <p style="font-size: 12px; color: var(--text-secondary); margin: 6px 0 22px;">Sign up to start scoping with structure.</p>

        <!-- Terms of Use + Privacy Policy consent: required before any signup method. -->
        <label class="consent-row">
          <input type="checkbox" class="consent-checkbox" [(ngModel)]="agreedToTerms" (ngModelChange)="onConsentChange()" />
          <span class="consent-text">
            I agree to the
            <a class="consent-link" href="#" (click)="legalModal = 'terms'; $event.preventDefault()">Terms of Use</a>
            and the
            <a class="consent-link" href="#" (click)="legalModal = 'privacy'; $event.preventDefault()">Privacy Policy</a>
          </span>
        </label>

        <button class="secondary-btn" style="margin-bottom: 10px;" (click)="signInWithGoogle()" [disabled]="isLoading || !agreedToTerms">
          <svg width="15" height="15" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.4-4.5 2.4-7.2 2.4-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.6l6.2 5.2c.4-.4 6.6-4.8 6.6-14.8 0-1.3-.1-2.4-.4-3.5z"/>
          </svg>
          Sign up with Google
        </button>

        <div class="divider"><hr/><span>OR</span><hr/></div>

        <!-- Signup Unified OTP Flow -->
        <ng-container *ngIf="signupOtpStep === 'identifier'">
          <p class="small-note" style="margin-bottom: 12px;">Enter your email or phone number to sign up.</p>
          <input type="text" class="auth-input" [(ngModel)]="signupIdentifier"
                 (ngModelChange)="onSignupIdentifierChange()"
                 (blur)="validateSignupIdentifier()"
                 (keyup.enter)="isValidSignupIdentifier && !isLoading && sendSignupOtp()"
                 placeholder="name@company.com or 9876543210" style="margin-bottom: 10px;" />
          <button class="primary-btn" (click)="sendSignupOtp()" [disabled]="!isValidSignupIdentifier || isLoading || !agreedToTerms">
            Send OTP <i class="ti ti-arrow-right" style="font-size: 14px;"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="signupOtpStep === 'otp'">
          <div class="back-link" (click)="goBackToSignupIdentifier()">
            <i class="ti ti-arrow-left" style="font-size: 13px;"></i> Change {{ signupIsEmail ? 'email' : 'number' }}
          </div>
          <p class="small-note" style="margin-bottom: 16px;">
            We sent a 6-digit code to <strong>{{ signupMaskedIdentifier }}</strong> via {{ signupIsEmail ? 'Email' : 'SMS' }}.
          </p>
          <input type="text" class="auth-input" [(ngModel)]="signupOtpCode" placeholder="------" maxlength="6"
                 (input)="formatSignupOtpInput($event)"
                 (keyup.enter)="signupOtpCode.length === 6 && !isLoading && verifySignupOtp()"
                 style="margin-bottom: 10px; text-align: center; letter-spacing: 4px;" />
          <button class="primary-btn" (click)="verifySignupOtp()" [disabled]="signupOtpCode.length !== 6 || isLoading || !agreedToTerms">
            Verify & Sign Up <i class="ti ti-arrow-right" style="font-size: 14px;"></i>
          </button>
          <div class="resend-row" style="margin-top: 14px; text-align: center;">
            <button type="button" class="resend-btn" [disabled]="signupOtpTimer > 0 || isLoading" (click)="resendSignupOtp()">
              <span *ngIf="signupOtpTimer > 0">Resend OTP in {{ signupOtpTimer }}s</span>
              <span *ngIf="signupOtpTimer === 0">Resend OTP</span>
            </button>
          </div>
        </ng-container>

        <div class="field-error" *ngIf="signupIdentifierError" style="margin-top: 12px;">
          <i class="ti ti-alert-circle" style="width: 14px; height: 14px;"></i>
          {{ signupIdentifierError }}
        </div>
        <div class="field-error" *ngIf="signupOtpError" style="margin-top: 12px;">
          <i class="ti ti-alert-circle" style="width: 14px; height: 14px;"></i>
          {{ signupOtpError }}
        </div>

        <p class="small-note">Already have an account? <span routerLink="/customers/login">Log in</span></p>
      </div>
    </div>
  </div>
</div>

<!-- Terms of Use / Privacy Policy reader (shared with vendor registration) -->
<app-legal-modal
  *ngIf="legalModal"
  [doc]="legalModal"
  (closed)="legalModal = null"
  (agreed)="agreeFromModal()">
</app-legal-modal>
